import filetype from 'magic-bytes.js'
import { MediaDimensions } from './dropZoneUploader.types'

export const normalizeMediaKey = (mediaKey: string) => {
  if (!mediaKey.includes('/')) {
    return mediaKey
  }

  const [, key] = mediaKey?.split('/') || []

  return key
}

export const getImageDimensions = (url: string): Promise<MediaDimensions> | void => {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.src = url

    img.onload = (event: Event) => {
      const image = event.target as HTMLImageElement

      resolve({
        width: image.width,
        height: image.height
      })
    }

    img.onerror = () => {
      reject(new Error('Failed to load the image.'))
    }
  })
}

export const checkMagicNumber = async (file: File): Promise<string | undefined> => {
  return new Promise((resolve) => {
    const fileReader = new FileReader()

    fileReader.onloadend = (event: ProgressEvent<FileReader>) => {
      const result = event.target?.result

      if (result instanceof ArrayBuffer) {
        const bytes = new Uint8Array(result)
        resolve(filetype(bytes)?.[0].mime)
      }
    }

    fileReader.readAsArrayBuffer(file)
  })
}

export const filesWithOriginalType = async (files: File[]): Promise<File[]> => {
  const filesWithMimeType = await Promise.all(
    files.map(async (file) => {
      const mimeType = await checkMagicNumber(file)

      return new File([file], file.name, {
        type: mimeType || file.type
      })
    })
  )

  return filesWithMimeType
}
